export default __webpack_public_path__ + "static/O0216-65082a7c535da3c40ed76a73b05b58c8.png";